module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Applications")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v(_vm._s(this.$store.state.client.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-1"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(this.$store.state.client.name))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Application ID:")]), _vm._v(" " + _vm._s(_vm.$route.params.client_id))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Package name:")]), _vm._v(" " + _vm._s(this.$store.state.client.package_name))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Platform:")]), _vm._v(" " + _vm._s(this.$store.state.client.platform))]), _c('p'), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Created at:")]), _vm._v(" " + _vm._s(this.$store.state.client.created_at))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Updated at:")]), _vm._v(" " + _vm._s(this.$store.state.client.updated_at))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Devices")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-4"
  }, [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$store.state.client.id) + "/devices")
    }
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.client.devices_count)))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Cameras")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-4"
  }, [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$store.state.client.id) + "/cameras")
    }
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.client.cameras_count)))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Articles")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-4"
  }, [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$store.state.client.id) + "/articles")
    }
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.client.articles_count)))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2 is-offset-1"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button is-primary is-outlined",
    attrs: {
      "to": ("/clients/" + (this.$store.state.client.id) + "/edit")
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-pencil"
  })]), _vm._v(" "), _c('span', [_vm._v("Edit")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icons-left"
  }, [_c('datepicker', {
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icons-left"
  }, [_c('datepicker', {
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }), _vm._v(" "), _vm._m(1)], 1)])])])])]), _vm._v(" "), _c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Devices during this period")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-4"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(_vm.devicesByPeriodsTotal)))])])]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Cameras during this period")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-4"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(_vm.camerasByPeriodsTotal)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('article', {
    staticClass: "box"
  }, [_c('chartjs-bar', {
    attrs: {
      "datalabel": 'Devices by period',
      "backgroundcolor": 'rgba(255, 99, 132, 0.5)',
      "bordercolor": 'rgba(255,99,132,1)',
      "borderwidth": 1,
      "bind": true,
      "labels": _vm.devicePeriods,
      "data": _vm.deviceAmounts
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('article', {
    staticClass: "box"
  }, [_c('chartjs-bar', {
    attrs: {
      "datalabel": 'Cameras by period',
      "backgroundcolor": 'rgba(255, 206, 86, 0.5)',
      "bordercolor": 'rgba(255, 206, 86, 1)',
      "borderwidth": 1,
      "bind": true,
      "labels": _vm.cameraPeriods,
      "data": _vm.cameraAmounts
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cc15e38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clients/ClientView.vue
// module id = 351
// module chunks = 1